import { adjustZodSchemaDefaultForUnknownFields } from '@juvare/platform-shared/features/validation';
import { z } from 'zod';
// hint: options supports additional unknown request fields for extended usage
export const accountOptionsRequestSchema = adjustZodSchemaDefaultForUnknownFields(z.object({
    organizationId: z.string().uuid().optional(),
}));
export const accountBadgeAccountRequestSchema = z.object({
    id: z.string().uuid(),
    options: accountOptionsRequestSchema,
});
